import { InputProps } from 'components/UI';
import InputWhite from 'components/common/InputWhite';

const SettingsInput = (props: InputProps) => (
  <InputWhite
    {...props}
    sx={{
      textAlign: 'center',
    }}
  />
);

export default SettingsInput;
